module.exports = __webpack_public_path__ + "static/media/LogicLever6_2_drag_2.97c6219c.png";